import React, {PureComponent} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import {
  FlexBox,
  FlexDirection,
  ComponentSize,
  AlignItems,
} from '@influxdata/clockface'
import ProviderOption from './ProviderOption'

import {getProviderInfo} from './selectors'

import {updateProviderInfo} from 'js/components/ProviderRegion/actions'

import {State, ProviderInfo, ProviderRegion} from 'js/types'

interface StateProps {
  selectedProvider: ProviderInfo
  allProviderRegions: ProviderRegion
}

interface DispatchProps {
  onSelectProvider: typeof updateProviderInfo
}
type Props = StateProps & DispatchProps

class ProviderPanelContents extends PureComponent<Props> {
  render() {
    const {allProviderRegions, selectedProvider, onSelectProvider} = this.props

    return (
      <>
        <input
          name="provider"
          type="hidden"
          value={selectedProvider.provider}
        />
        <FlexBox
          direction={FlexDirection.Row}
          margin={ComponentSize.Medium}
          alignItems={AlignItems.Stretch}
          stretchToFitWidth={true}
          className="provder-item--container"
        >
          {allProviderRegions.providerInfo.map((providerInfo) => {
            return (
              <ProviderOption
                key={providerInfo.provider}
                {...providerInfo}
                isSelected={selectedProvider.provider === providerInfo.provider}
                onClick={onSelectProvider}
              />
            )
          })}
        </FlexBox>
      </>
    )
  }
}

const mstp = (state: State): StateProps => ({
  selectedProvider: getProviderInfo(state),
  allProviderRegions: state.providerRegion.allProviderRegions,
})

const mdtp = (dispatch): DispatchProps =>
  bindActionCreators(
    {
      onSelectProvider: updateProviderInfo,
    },
    dispatch
  )

export default connect(mstp, mdtp)(ProviderPanelContents)
